import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Drawer from '@jetshop/ui/Modal/Drawer';
import styled, { css } from 'react-emotion';
import HeaderBg from '../../../img/header-background.jpg';
import { theme } from '../../Theme';

export const Flyout = styled.div`
  background: white;
  color: ${theme.colors.black};
  display: flex;
  flex-direction: column;

  ${theme.above.md} {
    position: absolute;
    z-index: 999;
    right: calc(50vw - 40rem);
    top: 100%;
    width: 22rem;
    min-width: 60rem;
    max-width: 100%;
    padding: 1rem;
    max-height: calc(
      100vh - ${theme.sizes.uspHeight} - ${theme.sizes.menuHeight} -
        ${theme.sizes.navHeight} - ${theme.spaces.sm}
    );
  }
`;

export const CloseIcon = styled(FontAwesomeIcon)`
  font-size: 1.5rem;
  color: black;
  margin-right: 10px;
`;

export const Header = styled('header')`
  position: relative;
  text-align: left;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0 0 1rem 0;
  margin: 0 0 1rem 0;
  ${theme.below.md} {
    padding: 0;
  }
`;

export const HeaderTitle = styled.h2`
  text-transform: uppercase;
  font-size: 1.5rem;
  margin-bottom: ${theme.spaces.xs};
  ${theme.above.md} {
    margin-bottom: 0px;
    font-size: 2rem;
  }
`;

export const GarageName = styled.span`
  margin-bottom: ${theme.spaces.xxs};
  ${theme.above.md} {
    margin-bottom: 0px;
  }
`;

export const FakeSelect = styled('div')`
  height: 54px;
  border: 1px solid #dedede;
  margin-bottom: 16px;
  color: #c2c2c2;
  line-height: 52px;
  padding-left: 16px;
  background: white;
`;

export const OptionsWrapper = styled('div')`
  width: 100%;
  padding: 1rem 10px;
  background-image: url(${HeaderBg});
  background-repeat: no-repeat;
  background-size: 200%;
  background-position: -120px -210px;
  ${theme.below.md} {
    background-size: cover;
    background-position: center;
  }
  .flex {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    ${theme.below.md} {
      flex-direction: column;
    }
    > div {
      flex: 1;
      margin: 10px;

      ${theme.below.md} {
        margin: 10px 0;
        max-height: 180px !important;
        > div {
          max-height: 180px;
          > div {
            max-height: 180px;
          }
        }
      }
    }
  }
`;

export const ModelFlyoutTitle = styled('span')`
  display: block;
  text-transform: uppercase;
  font-size: 1.8rem;
  color: white;
  margin-bottom: 5px;
  margin-left: 10px;
  ${theme.below.md} {
    font-size: 1.2rem;
    margin-bottom: 0;
  }
`;

export const StyledDrawer = styled(Drawer)`
  opacity: 0.5;
`;

export const SelectedModel = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spaces.sm};
  margin-bottom: 0.5rem;
  padding: 10px;
  flex-direction: column;
  ${theme.above.md} {
    flex-direction: row;
    padding: 0px;
  }
  a {
    text-transform: uppercase;
    flex: 1 0 auto;
  }
`;

export const MenuTitle = styled('div')`
  font-weight: bold;
  font-size: 16px;
  margin: 16px;

  ${theme.below.md} {
    text-align: right;
    margin: 0;
    padding: 10px;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: normal;
    text-transform: uppercase;

    svg {
      font-size: 2rem;
      margin-left: 10px;
    }
  }
`;

export const CloseModal = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
`;
export const EmptyButtonIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  margin-right: 10px;
  color: #a5a5a5;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spaces.sm};
`;

export const Garage = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: ${theme.spaces.sm};
  ${theme.above.md} {
    margin-top: ${theme.spaces.md};
    padding: 0;
  }
`;

export const GarageList = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;
  gap: ${theme.spaces.sm};
  flex-direction: column;
`;

export const GarageItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  ${theme.above.md} {
    flex-direction: row;
  }
`;

export const flex = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spaces.sm};
`;
